import { render, staticRenderFns } from "./createTask.vue?vue&type=template&id=6bc1d3cd&"
import script from "./createTask.vue?vue&type=script&lang=js&"
export * from "./createTask.vue?vue&type=script&lang=js&"
import style0 from "./createTask.vue?vue&type=style&index=0&id=6bc1d3cd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports